export default __webpack_public_path__ + "static/media/Amoxicilline.cc7c41d2.jpg";